// @flow

// --- Chart ---
export const xAxisLabel = {
  textStyle: {
    fontSize: 10,
    fontWeight: 500,
    letterSpacing: 0.5
  }
}



// WEBPACK FOOTER //
// ./src/components/chart-earnings/style.js